import { apiClient } from './api-client'
import { API_ENDPOINTS } from '@/config/constants'
import { GlobalStatistics, ClientsGraphData, ClientsStatusGraphData, GraphDto } from '@/types'

export const statisticsService = {
  getGlobalStatistics: async (): Promise<GlobalStatistics> => {
    return apiClient.get<GlobalStatistics>(API_ENDPOINTS.STATISTICS.BASE)
  },

  getClientsGraph: async (graphDto?: GraphDto): Promise<ClientsGraphData> => {
    return apiClient.post<ClientsGraphData>(
      `${API_ENDPOINTS.STATISTICS.BASE}/clients`,
      graphDto || {}
    )
  },

  getClientsStatusGraph: async (graphDto?: GraphDto): Promise<ClientsStatusGraphData> => {
    return apiClient.post<ClientsStatusGraphData>(
      `${API_ENDPOINTS.STATISTICS.BASE}/clients-status`,
      graphDto || {}
    )
  },
}
